const initialState = {
    fetching: true,
    status: null,
};

export default function facebook(state = initialState, action) {
    switch (action.type) {
        case 'FACEBOOK_CONNECTED':
            return {
                fetching: false,
                status: 'connected',
            };
        case 'FACEBOOK_NOT_AUTHORIZED':
            return {
                fetching: false,
                status: 'not_authorized',
            };
        case 'FACEBOOK_NOT_LOGGED_IN':
            return {
                fetching: false,
                status: 'not_logged_in',
            };
        default:
            return state;
    }
}
